import {
  _UShort___init__impl__jigrne3vu9egv7mch1k as _UShort___init__impl__jigrne,
  _UShort___get_data__impl__g0245313795p1x5hw5 as _UShort___get_data__impl__g0245,
  UShort26xnqty60t7le as UShort,
} from './UShort.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from './exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { containscs3vsq7ynpxl as contains } from './collections/_Arrays.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from './hacks.mjs';
import { Collection1k04j3hzsbod0 as Collection } from './collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from './js/typeCheckUtils.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from './js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _UShortArray___init__impl__9b26ef(storage) {
  return storage;
}
function _UShortArray___get_storage__impl__t2jpv5($this) {
  return $this;
}
function _UShortArray___init__impl__9b26ef_0(size) {
  return _UShortArray___init__impl__9b26ef(new Int16Array(size));
}
function UShortArray__get_impl_fnbhmx($this, index) {
  // Inline function 'kotlin.toUShort' call
  var this_0 = _UShortArray___get_storage__impl__t2jpv5($this)[index];
  return _UShort___init__impl__jigrne(this_0);
}
function UShortArray__set_impl_6d8whp($this, index, value) {
  var tmp = _UShortArray___get_storage__impl__t2jpv5($this);
  // Inline function 'kotlin.UShort.toShort' call
  tmp[index] = _UShort___get_data__impl__g0245(value);
}
function _UShortArray___get_size__impl__jqto1b($this) {
  return _UShortArray___get_storage__impl__t2jpv5($this).length;
}
function UShortArray__iterator_impl_ktpenn($this) {
  return new (Iterator())(_UShortArray___get_storage__impl__t2jpv5($this));
}
var IteratorClass;
function Iterator() {
  if (IteratorClass === VOID) {
    class $ {
      constructor(array) {
        this.ev_1 = array;
        this.fv_1 = 0;
      }
      q1() {
        return this.fv_1 < this.ev_1.length;
      }
      gv() {
        var tmp;
        if (this.fv_1 < this.ev_1.length) {
          var _unary__edvuaz = this.fv_1;
          this.fv_1 = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.toUShort' call
          var this_0 = this.ev_1[_unary__edvuaz];
          tmp = _UShort___init__impl__jigrne(this_0);
        } else {
          throw NoSuchElementException().a2(this.fv_1.toString());
        }
        return tmp;
      }
      r1() {
        return new (UShort())(this.gv());
      }
    }
    initMetadataForClass($, 'Iterator');
    IteratorClass = $;
  }
  return IteratorClass;
}
function UShortArray__contains_impl_vo7k3g($this, element) {
  var tmp = _UShortArray___get_storage__impl__t2jpv5($this);
  // Inline function 'kotlin.UShort.toShort' call
  var tmp$ret$0 = _UShort___get_data__impl__g0245(element);
  return contains(tmp, tmp$ret$0);
}
function UShortArray__contains_impl_vo7k3g_0($this, element) {
  if (!(element instanceof UShort()))
    return false;
  return UShortArray__contains_impl_vo7k3g($this.hv_1, element instanceof UShort() ? element.cv_1 : THROW_CCE());
}
function UShortArray__containsAll_impl_vlaaxp($this, elements) {
  var tmp0 = isInterface(elements, Collection()) ? elements : THROW_CCE();
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.n1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp_0;
      if (element instanceof UShort()) {
        var tmp_1 = _UShortArray___get_storage__impl__t2jpv5($this);
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = element.cv_1;
        var tmp$ret$2 = _UShort___get_data__impl__g0245(this_0);
        tmp_0 = contains(tmp_1, tmp$ret$2);
      } else {
        tmp_0 = false;
      }
      if (!tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function UShortArray__containsAll_impl_vlaaxp_0($this, elements) {
  return UShortArray__containsAll_impl_vlaaxp($this.hv_1, elements);
}
function UShortArray__isEmpty_impl_cdd9l0($this) {
  return _UShortArray___get_storage__impl__t2jpv5($this).length === 0;
}
function UShortArray__toString_impl_omz03z($this) {
  return 'UShortArray(storage=' + toString($this) + ')';
}
function UShortArray__hashCode_impl_2vt3b4($this) {
  return hashCode($this);
}
function UShortArray__equals_impl_tyc3mk($this, other) {
  if (!(other instanceof UShortArray()))
    return false;
  var tmp0_other_with_cast = other.hv_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var UShortArrayClass;
function UShortArray() {
  if (UShortArrayClass === VOID) {
    class $ {
      constructor(storage) {
        this.hv_1 = storage;
      }
      q2() {
        return _UShortArray___get_size__impl__jqto1b(this.hv_1);
      }
      p1() {
        return UShortArray__iterator_impl_ktpenn(this.hv_1);
      }
      iv(element) {
        return UShortArray__contains_impl_vo7k3g(this.hv_1, element);
      }
      t2(element) {
        return UShortArray__contains_impl_vo7k3g_0(this, element);
      }
      jv(elements) {
        return UShortArray__containsAll_impl_vlaaxp(this.hv_1, elements);
      }
      q4(elements) {
        return UShortArray__containsAll_impl_vlaaxp_0(this, elements);
      }
      n1() {
        return UShortArray__isEmpty_impl_cdd9l0(this.hv_1);
      }
      toString() {
        return UShortArray__toString_impl_omz03z(this.hv_1);
      }
      hashCode() {
        return UShortArray__hashCode_impl_2vt3b4(this.hv_1);
      }
      equals(other) {
        return UShortArray__equals_impl_tyc3mk(this.hv_1, other);
      }
    }
    initMetadataForClass($, 'UShortArray', VOID, VOID, [Collection()]);
    UShortArrayClass = $;
  }
  return UShortArrayClass;
}
//region block: exports
export {
  _UShortArray___init__impl__9b26ef_0 as _UShortArray___init__impl__9b26efzwhnyvfbg58m,
  _UShortArray___init__impl__9b26ef as _UShortArray___init__impl__9b26ef2fr8vrbufr3j6,
  UShortArray__get_impl_fnbhmx as UShortArray__get_impl_fnbhmx1exua9mtkbdj1,
  UShortArray__set_impl_6d8whp as UShortArray__set_impl_6d8whp179ynmfb9d38q,
  _UShortArray___get_size__impl__jqto1b as _UShortArray___get_size__impl__jqto1b3rfx6oix6j8vx,
  _UShortArray___get_storage__impl__t2jpv5 as _UShortArray___get_storage__impl__t2jpv53oc7c1c2s7ixe,
  UShortArray as UShortArray11avpmknxdgvv,
};
//endregion

//# sourceMappingURL=UShortArray.mjs.map
